import React, { FC, useMemo } from "react";
import classes from "./style/IndividualCardInfo.module.css";
import { Input, Form, Checkbox, InputNumber, Select } from "antd";
import {
  ruleRequired,
  ruleText,
} from "../../../../../../../constants/rules/RulesConstantsForms";
import { MemberFL } from "../../../../../../../store/types/applicationBank.type";

interface IndividualCardInfoProps {
  individual: MemberFL;
}

export const IndividualCardInfo: FC<IndividualCardInfoProps> = ({
  individual,
}) => {
  const initialValues = useMemo(() => {
    return {
      ...individual?.member_passport_fl,
      passport_birth:
        individual?.member_passport_fl.passport_birth?.split(" ")[0],
      passport_issue_date:
        individual?.member_passport_fl.passport_issue_date?.split(" ")[0],
      snils: individual.snils,
      percent: individual.percent,
      is_eio: individual.is_eio,
      is_founder: individual.is_founder,
      post_and_registration_address: individual.post_and_registration_address,
      passport_post_index: individual.member_passport_fl.passport_post_index,
      passport_post_address:
        individual.member_passport_fl.passport_post_address,
      position: individual.position || "",
      actsPursuant: individual.acts_pursuant || "charter",
    };
  }, [individual]);

  return (
    <div className={classes.individualInfoContainer}>
      <Form layout="vertical" initialValues={initialValues} disabled>
        <div className={classes.formInputWrapper}>
          <Form.Item label="Фамилия" name="passport_surname">
            <Input placeholder="Введите фамилию" />
          </Form.Item>
          <Form.Item label="Имя" name="passport_name">
            <Input placeholder="Введите имя" />
          </Form.Item>
          <Form.Item label="Отчество" name="passport_patronymic">
            <Input placeholder="Введите отчество" />
          </Form.Item>
          <Form.Item label="Дата рождения" name="passport_birth">
            <Input type="date" placeholder="Введите дату рождения" />
          </Form.Item>
        </div>
        <div className={classes.formInputWrapper}>
          <Form.Item label="Серия" name="passport_series">
            <Input placeholder="Введите cерию" />
          </Form.Item>
          <Form.Item label="Номер" name="passport_number">
            <Input placeholder="Введите номер" />
          </Form.Item>
          <Form.Item label="Код подразделения" name="passport_division_code">
            <Input placeholder="Введите код подразделения" />
          </Form.Item>
          <Form.Item label="Дата выдачи" name="passport_issue_date">
            <Input type="date" placeholder="Введите дату выдачи" />
          </Form.Item>
        </div>
        <Form.Item label="Когда и кем выдан" name="passport_department">
          <Input placeholder="Введите когда и кем выдан" />
        </Form.Item>
        <Form.Item label="Место рождения" name="passport_place_birth">
          <Input placeholder="Введите место рождения" />
        </Form.Item>
        <div className={classes.formInputWrapperAdress}>
          <Form.Item
            label="Индекс"
            style={{ width: "220px" }}
            name="passport_post_index"
          >
            <Input placeholder="Введите индекс" />
          </Form.Item>
          <Form.Item
            label="Адрес регистрации"
            style={{ flex: "1 0" }}
            name="passport_address"
          >
            <Input placeholder="Введите адрес регистрации" />
          </Form.Item>
        </div>

        <Form.Item valuePropName="checked" name="post_and_registration_address">
          <Checkbox>Адрес регистрации совпадает с местом жительства</Checkbox>
        </Form.Item>
        {!individual.post_and_registration_address && (
          <Form.Item name="passport_post_address" label="Место жительства">
            <Input />
          </Form.Item>
        )}
        <Form.Item label="Снилс" name="snils">
          <Input placeholder="Введите снилс" />
        </Form.Item>
        <div className={classes.formInputWrapper}>
          <Form.Item
            valuePropName="checked"
            style={{ alignSelf: "end" }}
            name="is_founder"
          >
            <Checkbox>Является учредителем</Checkbox>
          </Form.Item>
          <Form.Item
            valuePropName="checked"
            style={{ alignSelf: "end" }}
            name="is_eio"
          >
            <Checkbox>Является ЕИО</Checkbox>
          </Form.Item>
        </div>
        <div className={classes.formInputWrapperSelect}>
          <Form.Item
            label="Доля УК физического лица"
            name="percent"
            rules={[ruleRequired]}
          >
            <InputNumber<number>
              style={{ width: "100%" }}
              placeholder="Введите долю УК"
              min={0}
              max={100}
              suffix="%"
              controls={false}
            />
          </Form.Item>
          {individual?.is_eio && (
            <>
              <Form.Item
                label="Действует на основании"
                name="actsPursuant"
                rules={[ruleRequired]}
              >
                <Select
                  options={[
                    { value: "charter", label: "Устава" },
                    {
                      value: "powerOfAttorney",
                      label: "Доверенности",
                    },
                    { value: "decision", label: "Решения" },
                    { value: "protocol", label: "Протокола" },
                    { value: "order", label: "Приказа" },
                  ]}
                />
              </Form.Item>
              <Form.Item
                label="Должность"
                rules={[ruleRequired, ruleText]}
                name="position"
              >
                <Input />
              </Form.Item>
            </>
          )}
        </div>
      </Form>
    </div>
  );
};
